var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70525 15.5859L15.5858 7.70528C15.1606 6.9857 14.9166 6.14634 14.9166 5.24999C14.9166 2.58061 17.0806 0.416656 19.75 0.416656C22.4193 0.416656 24.5833 2.58061 24.5833 5.24999C24.5833 7.91937 22.4193 10.0833 19.75 10.0833C18.8536 10.0833 18.0142 9.83932 17.2947 9.41412L9.41409 17.2947C9.83929 18.0143 10.0833 18.8536 10.0833 19.75C10.0833 22.4194 7.91934 24.5833 5.24996 24.5833C2.58058 24.5833 0.416626 22.4194 0.416626 19.75C0.416626 17.0806 2.58058 14.9167 5.24996 14.9167C6.14631 14.9167 6.98567 15.1607 7.70525 15.5859ZM5.24996 22.1667C6.58465 22.1667 7.66663 21.0847 7.66663 19.75C7.66663 18.4153 6.58465 17.3333 5.24996 17.3333C3.91527 17.3333 2.83329 18.4153 2.83329 19.75C2.83329 21.0847 3.91527 22.1667 5.24996 22.1667ZM19.75 7.66666C21.0846 7.66666 22.1666 6.58468 22.1666 5.24999C22.1666 3.9153 21.0846 2.83332 19.75 2.83332C18.4153 2.83332 17.3333 3.9153 17.3333 5.24999C17.3333 6.58468 18.4153 7.66666 19.75 7.66666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTable);
export default __webpack_public_path__ + "static/media/WhiteTable.811c63ffef152e3dc5a556282a7d5ade.svg";
export { ForwardRef as ReactComponent };